import React, { useMemo } from 'react';
import {
  LoginFlowVariant,
  useHomeHeroAuthenticationStepData,
} from '@/store/authentication/AuthenticationStore';
import LoginViaSmsForm from '@/features/authentication/login/LoginViaSmsForm';
import LoginForm from '@/features/authentication/login/LoginForm';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { useSelector } from 'react-redux';

const Login = () => {
  const { loginFlowVariant } = useHomeHeroAuthenticationStepData();
  const locale = useSelector(selectLocale);

  return useMemo(() => {
    // for now we still only want to show the Mobile variant to TH locale
    if (loginFlowVariant === LoginFlowVariant.Mobile && locale === 'th') {
      return <LoginViaSmsForm />;
    }

    return <LoginForm />;
  }, [loginFlowVariant, locale]);
};

export default Login;
